import { useEffect, useState } from "react";

export const applySeo = (s) => {
  if (!s) return;
  document.title = `${s.name} | ${s.tagline}`;
  const desc = `${s.name} — ${s.tagline} ${s.intro}`.slice(0, 300);
  let meta = document.querySelector('meta[name="description"]');
  if (!meta) {
    meta = document.createElement("meta");
    meta.name = "description";
    document.head.appendChild(meta);
  }
  meta.content = desc;
};

export const useFetch = (fn, deps) => {
  const [state, setState] = useState({ data: null, error: null, loading: true });
  useEffect(() => {
    let alive = true;
    setState((s) => ({ ...s, loading: true }));
    fn()
      .then((r) => alive && setState({ data: r.data, error: null, loading: false }))
      .catch((e) => alive && setState({ data: null, error: e, loading: false }));
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
  return state;
};

export const PageLoader = ({ testId = "page-loading" }) => (
  <div className="grid min-h-screen place-items-center bg-[#121214]" data-testid={testId}>
    <span className="font-display animate-pulse text-3xl text-zinc-500">JIMMY<span className="text-[#FFD23F]">Z</span> RESTOZ</span>
  </div>
);
